// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3z-F_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2AQAX"};